import { hasFeatureCanary, WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { AxiosRequestConfig } from 'axios';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { clientType, getClientType } from 'Environment/getClientType';
import {
	isChrome,
	isChromeAppOrChromeOS,
	isEdge,
	isLinux,
	isMac,
	isNativeClient,
	isSafari,
	isWindowsPlatform,
} from 'Environment/launchResource/device';
import { isResourceEnumerationCall } from 'javascript/interceptors/workspacePlatform';

const ishtml5AlwaysEnabled = (workspaceConfiguration: WorkspaceConfiguration) => {
	const { html5 } = workspaceConfiguration?.pluginAssistant || {};
	return html5?.enabled?.toLowerCase() === 'always';
};

const supportsWebExtension = () => {
	return (
		((isChrome() || isEdge()) && (isWindowsPlatform() || isMac() || isLinux())) ||
		(isSafari() && isMac())
	);
};

const isSupportedClient = (workspaceConfiguration: WorkspaceConfiguration) => {
	const currentClientType = getClientType();
	const html5AlwaysEnabled = ishtml5AlwaysEnabled(workspaceConfiguration);
	return (
		!html5AlwaysEnabled &&
		currentClientType !== clientType.html5 &&
		currentClientType !== clientType.chromeapp &&
		!isChromeAppOrChromeOS()
	);
};

export function checkCombinedAppProtectionCapable(
	workspaceConfiguration: WorkspaceConfiguration,
	requestConfiguration: AxiosRequestConfig
): boolean {
	if (!hasFeatureCanary(workspaceConfiguration, FeatureFlag.BrowserAppProtection)) {
		return false;
	}

	if (isNativeClient()) {
		return false;
	}

	if (workspaceConfiguration?.appProtection?.enabled?.toLowerCase() === 'on') {
		return isSupportedClient(workspaceConfiguration);
	}

	if (
		workspaceConfiguration?.appProtection?.enabled?.toLowerCase() ===
		'requireswebextension'
	) {
		if (isResourceEnumerationCall(workspaceConfiguration, requestConfiguration)) {
			return (
				getClientType() !== clientType.html5 &&
				!ishtml5AlwaysEnabled(workspaceConfiguration) &&
				supportsWebExtension()
			);
		} else {
			return getClientType() === clientType.browserextension;
		}
	}

	return false;
}
